<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('quotation.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('quotation.pageTitle'),
            href: '/admin/quotations',
          },
          {
            text: $t('update'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <form class="form-horizontal">
			<div class="ts-border ts-p-3 ts-rounded ts-shadow">
			<div class="row">
			<div class="col-md-6 ts-space-y-3">
				<div class="row">
				<label class="col-md-3 col-form-label required">{{
					$t('quotation.date')
				}}</label>
				<div class="col-md-6">
					<a-date-picker
					v-model="model.quotation_date"
					format="DD-MM-YYYY"
					valueFormat="DD-MM-YYYY"
					class="ts-w-full"
					></a-date-picker>
					<div class="validate" v-if="errors.has('quotation_date')">
					{{ errors.first('quotation_date') }}
					</div>
				</div>
				</div>
				<div class="row">
				<label class="col-md-3 col-form-label required">{{
					$t('quotation.customer')
				}}</label>
				<div class="col-md-6">
					<a-select
					v-model="model.customer_id"
					:filterOption="
						(input, option) =>
						option.componentOptions.children[0].text
							.toLowerCase()
							.indexOf(input.toLowerCase()) >= 0
					"
					showSearch
					@change="customerChange"
					:options="customerList"
					class="ts-w-full"
					></a-select>
					<div class="validate" v-if="errors.has('customer_id')">
					{{ errors.first('customer_id') }}
					</div>
				</div>
				</div>
				<div class="row">
				<label class="col-md-3 col-form-label required">{{
					$t('quotation.creditTerm')
				}}</label>
				<div class="col-md-6">
					<input
					v-model.trim="model.credit_term"
					type="text"
					class="form-control"
					/>
					<div class="validate" v-if="errors.has('credit_term')">
					{{ errors.first('credit_term') }}
					</div>
				</div>
				</div>
				<div class="row">
				<label class="col-md-3 col-form-label required">{{
					$t('quotation.validUntil')
				}}</label>
				<div class="col-md-6">
					<a-date-picker
					v-model="model.valid_until"
					format="DD-MM-YYYY"
					valueFormat="DD-MM-YYYY"
					class="ts-w-full"
					></a-date-picker>
					<div class="validate" v-if="errors.has('valid_until')">
					{{ errors.first('valid_until') }}
					</div>
				</div>
				</div>
			</div>
			<div class="col-md-6 ts-space-y-3">
				<div class="row">
				<label class="col-md-3 col-form-label">{{
					$t('quotation.projectName')
				}}</label>
				<div class="col-md-6">
					<input
					v-model.trim="model.project_name"
					type="text"
					class="form-control"
					/>
					<div class="validate" v-if="errors.has('project_name')">
					{{ errors.first('project_name') }}
					</div>
				</div>
				</div>
				<div class="row">
				<label class="col-md-3 col-form-label required">{{
					$t('quotation.pic')
				}}</label>
				<div class="col-md-6">
					<input
					v-model.trim="model.pic"
					type="text"
					class="form-control"
					/>
					<div class="validate" v-if="errors.has('pic')">
					{{ errors.first('pic') }}
					</div>
				</div>
				</div>
			</div>
			</div>
			</div>
            <br />
            <div class="row">
              <div class="col-md-12">
                <Detail v-model="model" :validate="errors" class="ts-shadow-inner ts-p-3 ts-rounded"/>
              </div>
            </div>
            <div class="row ts-mt-4">
              <div class="col-md-12 ts-flex ts-justify-end ts-space-x-2">
                <ts-button
                  @click.prevent="$router.push({ name: 'quotation' })"
                  >{{ $t('cancel') }}</ts-button
                >
                <ts-button
                  :waiting="waiting"
                  @click.prevent="saveAddNew"
                  color="primary"
                  >{{ $t('savePrint') }}</ts-button
                >
              </div>
            </div>
          </form>
        </ts-loading-banner>
        <a-modal
          :title="$t('pdf')"
          width="50%"
          v-model="show_pdf"
          :footer="null"
        >
          <ts-preview-pdf v-model="waiting" :src="src" />
        </a-modal>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import Detail from './components/item-detail'
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  name: 'quotationCreate',
  components: {
    Detail,
  },
  data() {
    return {
      waiting: false,
      loading: false,
      show_pdf: false,
      errors: new Errors(),
      src: null,
      model: {
        quotation_date: moment().format('DD-MM-YYYY'),
        project_name: null,
        pic: null,
        customer_id: null,
        grand_total: null,
        vat_rate: null,
        vat_amount: null,
        total_exclude_vat: null,
        credit_term: null,
        valid_until: null,
        item_list: [],
      },
    }
  },
  async created() {
    this.model.vat_rate = parseFloat(
      this.$store.state.authUser.sys_setting.vat_rate
    )
    this.loading = true
    await this.fetchResource()
    await this.find(this.$route.params.id)
    await this.setEditData()
    this.loading = false
  },
  computed: {
    ...mapState('wholesale/quotation', ['customers', 'edit_data']),
    ...mapGetters('wholesale/quotation', ['getCreditDay']),
    decimalDigit() {
      return this.$store.state.authUser.sys_setting.decimal_digit || 2 
    },
    customerList() {
      return this.customers.map((el) => ({
        value: el.customer_id,
        label: el.customer_name,
      }))
    },
  },
  methods: {
    ...mapActions('wholesale/quotation', ['fetchResource', 'update', 'find']),
    saveAddNew() {
      this.waiting = true
      this.show_pdf = true
      this.errors = new Errors()
      this.update({
        id: this.model.quotation_id,
        data: this.model,
      })
        .then((response) => {
          this.src = response.url
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      this.model.quotation_id = this.edit_data.quotation_id
      this.model.quotation_date = this.edit_data.quotation_date
      this.model.project_name = this.edit_data.project_name
      this.model.pic = this.edit_data.person_in_charge
      this.model.customer_id = this.edit_data.customer_id
      this.model.grand_total = this.edit_data.grand_total
      this.model.vat_rate = this.edit_data.vat_rate
      this.model.vat_amount = this.edit_data.vat_amount
      this.model.credit_term = this.edit_data.credit_term
      this.model.valid_until = this.edit_data.valid_until
      this.model.total_exclude_vat = this.edit_data.total_exclude_vat
      this.model.item_list = []
      this.edit_data.details.forEach((el) => {
        this.model.item_list.push({
          product_id: el.product_id,
          uom_id: el.uom_id,
          quantity: el.quantity,
          unit_price: _.round(el.unit_price, this.decimalDigit),
          remarks: el.remarks,
          amount: _.round(el.quantity * el.unit_price, this.decimalDigit),
        })
      })
    },
    customerChange(value, option) {
      this.model.credit_term = this.getCreditDay(value)
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('wholesale/quotation/CLEAR_SETUP')
    next()
  },
}
</script>